import React from "react";
import { motion } from "framer-motion";

/**
 * MaskedLines — line-by-line masked reveal for hero titles.
 * Pass `lines` as an array of strings; each line is masked (overflow-hidden)
 * and translates up on mount with staggered delay.
 */
export default function MaskedLines({
    lines,
    className = "",
    lineClassName = "",
    baseDelay = 0.1,
    duration = 1.05,
    stagger = 0.12,
    as: Tag = "h1",
}) {
    return (
        <Tag className={className} aria-label={lines.join(" ")}>
            {lines.map((line, i) => (
                <span
                    key={i}
                    aria-hidden="true"
                    className="block overflow-hidden"
                >
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration,
                            delay: baseDelay + i * stagger,
                            ease: [0.22, 1, 0.36, 1],
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}
